var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3385 7.87673V3.67959C20.3385 2.37607 19.7469 1.84912 18.277 1.84912H14.5421C13.0721 1.84912 12.4805 2.37607 12.4805 3.67959V7.86748C12.4805 9.18024 13.0721 9.69795 14.5421 9.69795H18.277C19.7469 9.70719 20.3385 9.18024 20.3385 7.87673Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.66406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3385 18.277V14.5421C20.3385 13.0721 19.7469 12.4805 18.277 12.4805H14.5421C13.0721 12.4805 12.4805 13.0721 12.4805 14.5421V18.277C12.4805 19.7469 13.0721 20.3385 14.5421 20.3385H18.277C19.7469 20.3385 20.3385 19.7469 20.3385 18.277Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.66406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70695 7.87673V3.67959C9.70695 2.37607 9.11528 1.84912 7.64536 1.84912H3.91047C2.44054 1.84912 1.84888 2.37607 1.84888 3.67959V7.86748C1.84888 9.18024 2.44054 9.69795 3.91047 9.69795H7.64536C9.11528 9.70719 9.70695 9.18024 9.70695 7.87673Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.66406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70695 18.277V14.5421C9.70695 13.0721 9.11528 12.4805 7.64536 12.4805H3.91047C2.44054 12.4805 1.84888 13.0721 1.84888 14.5421V18.277C1.84888 19.7469 2.44054 20.3385 3.91047 20.3385H7.64536C9.11528 20.3385 9.70695 19.7469 9.70695 18.277Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.66406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.8de30d2085e4e243628a7f8947d0120e.svg";
export { ForwardRef as ReactComponent };